import { useTranslation } from 'react-i18next';

import { gql, useMutation } from '@apollo/client';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';

const SEND_CHANGE_EMAIL_LINK = gql`
  mutation sendChangeEmailLink($payload: UpdateCurrentAccountInput!) {
    sendChangeEmailLink(payload: $payload)
  }
`;

export const useSendChangeEmailLink = () => {
  const { t } = useTranslation(['common', 'settings']);

  const [sendChangeEmailLink] = useMutation(SEND_CHANGE_EMAIL_LINK, {
    onCompleted: () =>
      showNotification({
        type: NOTIFICATION_TYPE.success,
        message: t('settings:userProfileSettings.success.confirmationLinkSent'),
      }),
    onError: ({ message }: { message: string }) => {
      if (message === 'email-already-exists') {
        return showNotification({
          type: NOTIFICATION_TYPE.error,
          message: t('common:notifications.emailAlreadyExists.title'),
        });
      }
      return showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('common:notifications.error.title'),
        description: t('common:notifications.error.subTitle'),
      });
    },
  });

  return sendChangeEmailLink;
};
